module.exports = __webpack_public_path__ + "static/stalmark-logo-fc2db6b2ea7f4b0af8f42d9810b4bb46.svg";